import { getFilterMetadata } from '../../../../components/StatelessComponent/FilterChainUtils';
import type {
  BasicListOption,
  LargeListFilterValue,
} from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericLargeListFilter/GenericLargeListType';
import { LargeListFilterOperation } from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericLargeListFilter/GenericLargeListType';
import type { ListOption } from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericShortListFilter/GenericShortListDropdown';
import type { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import type { LabelProps } from '../../LabelFormatterType';

export const DEFAULT_MAX_DISPLAYED_ITEMS = 1;

export const getValueLabel = <T>(
  currentValue: LargeListFilterValue<T> | undefined,
  optionList: readonly BasicListOption<T>[] | undefined,
  maxDisplayedItems = DEFAULT_MAX_DISPLAYED_ITEMS,
): string => {
  if (currentValue == null || optionList == null) {
    return '';
  }
  const operation =
    LargeListFilterOperation.IS_ANY_OF_THESE === currentValue.operation ? 'is' : 'is not';

  if (currentValue.selectedValues.length > maxDisplayedItems) {
    return `${operation} (${currentValue.selectedValues.length})`;
  }

  const options: BasicListOption<T>[] = currentValue.selectedValues.map(
    (item) => optionList.find((option) => option.value === item) as BasicListOption<T>,
  );

  if (options.some((item) => item == null)) {
    return 'unknown option';
  }

  return options.reduce((output, option, index) => {
    let result = `${output} "${option.label}"`;
    if (index < options.length - 2) {
      result += ', ';
    } else if (index === options.length - 2) {
      result += ' or ';
    }
    return result;
  }, operation);
};

export const getLabels = <T>(
  currentValue: LargeListFilterValue<T> | undefined,
  filterKind: FilterKindEnum,
  options: {
    optionList: readonly ListOption<T>[] | undefined;
    maxDisplayedItems?: number;
  },
): LabelProps => {
  const metadata = getFilterMetadata(filterKind);
  return {
    label1: metadata.filterName,
    label2: getValueLabel(currentValue, options.optionList, options.maxDisplayedItems),
  };
};
